import React, { FormEvent, useEffect, useState } from 'react';
import Header from '../../components/Header';
import Menu from '../../components/Menu';
import './Main.scss';

import * as ReactInputRange from 'react-input-range';
const InputRange: typeof ReactInputRange.default = ReactInputRange as any;
import 'react-input-range/lib/css/index.css';
import { sintomas, sintomasResp } from './sintomas';
import { calculateAll, calculateIMC } from './calculate';
import { AiOutlineRight } from 'react-icons/ai';
import InputMask from 'react-input-mask';
import NumberFormat from 'react-number-format';
interface Iform {
  sexo: string;
  historicoFamiliar: boolean;
  sedentario: number;
  gravidez: number;
  idade: number;
  peso: number;
  altura: number;
  sintomas: number;
  sintomasClinicos?: Isintomas[];
}
export interface Isintomas {
  image: JSX.Element;
  title: string;
  selected: boolean;
  id: number;
}
export interface IresponseItens {
  idadeVeia: number;
  imc: any;
  risks: IresponseRisks[];
}

interface IresponseRisks {
  year: string;
  typeRisks: any;
  show: boolean;
}

const isMobile = window.innerWidth <= 450 ? true : false;

const Main: React.FC = () => {
  const [formInputs, setFormInputs] = useState<Iform>({
    sexo: 'F',
    historicoFamiliar: true,
    sedentario: 1,
    gravidez: 0,
    idade: 30,
    peso: 65,
    altura: 120,
    sintomas: 0,
  });

  const [listSintomas, setListSintomas] = useState<Isintomas[]>([]);
  const [response, setResponse] = useState<boolean>(false);
  const [responseItens, setResponseItens] = useState<IresponseItens>({
    idadeVeia: 0,
    imc: {},
    risks: [],
  });

  useEffect(() => {
    setListSintomas(sintomas);
  }, []);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    console.log(formInputs.altura);

    if (formInputs.altura < 100) formInputs.altura = formInputs.altura * 100;

    const imc = calculateIMC(
      formInputs.idade,
      formInputs.peso,
      formInputs.altura
    );
    const { obesidade } = imc;

    const calculate = calculateAll(
      formInputs.sexo,
      formInputs.idade,
      formInputs.historicoFamiliar,
      formInputs.sedentario,
      obesidade,
      formInputs.gravidez,
      formInputs.sintomas,
      listSintomas
    );

    const calculate20 = calculateAll(
      formInputs.sexo,
      formInputs.idade + 10,
      formInputs.historicoFamiliar,
      formInputs.sedentario,
      obesidade,
      formInputs.gravidez,
      formInputs.sintomas,
      listSintomas
    );

    const calculate40 = calculateAll(
      formInputs.sexo,
      formInputs.idade + 20,
      formInputs.historicoFamiliar,
      formInputs.sedentario,
      obesidade,
      formInputs.gravidez,
      formInputs.sintomas,
      listSintomas
    );

    const tiposResposta: IresponseRisks[] = [
      {
        year: 'Em 10 anos',
        typeRisks: calculate.riscos,
        show: true,
      },
      {
        year: 'Em 20 anos',
        typeRisks: calculate20.riscos,
        show: formInputs.idade < 50,
      },
      {
        year: 'Em 30 anos',
        typeRisks: calculate40.riscos,
        show: formInputs.idade < 40,
      },
    ];

    setResponseItens({
      idadeVeia: calculate.idade,
      imc: imc,
      risks: tiposResposta,
    });
    setResponse(true);
  };

  const goBackQuestion = (reset: boolean) => {
    setResponse(false);
    if (reset) {
      setFormInputs({
        sexo: 'F',
        historicoFamiliar: true,
        sedentario: 0,
        gravidez: 0,
        idade: 30,
        peso: 65,
        altura: 120,
        sintomas: 0,
      });
      setResponseItens({
        idadeVeia: 0,
        imc: {},
        risks: [],
      });
      setListSintomas(sintomas);
    }
  };

  const formatAltura = (value: any = '') => {
    let format = Number(value).toFixed(2);
    format = format.replace(/\D/g, '');
    format = format.replace(/(\d{1})(\d)/, '$1.$2');
    return format;
  };

  return (
    <>
      <Header />
      <div className="container">
        <Menu />
        <div className="content main">
          {!response ? (
            <>
              <form action="" onSubmit={handleSubmit}>
                <div className="form-group">
                  <span className="label">Sexo</span>
                  <div className="custom-radio">
                    <label className={formInputs.sexo === 'F' ? 'active' : ''}>
                      Feminino
                      <input
                        type="radio"
                        id="sex1"
                        value="F"
                        name="sex"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sexo: 'F',
                          });
                        }}
                      />
                    </label>
                    <label className={formInputs.sexo === 'M' ? 'active' : ''}>
                      Masculino
                      <input
                        type="radio"
                        id="sex2"
                        value="M"
                        name="sex"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sexo: 'M',
                          });
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <span className="label">Histórico Familiar</span>
                  <div className="custom-radio">
                    <label
                      className={formInputs.historicoFamiliar ? 'active' : ''}
                    >
                      SIM
                      <input
                        type="radio"
                        id="historico1"
                        value="sim"
                        name="historico"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            historicoFamiliar: true,
                          });
                        }}
                      />
                    </label>
                    <label
                      className={!formInputs.historicoFamiliar ? 'active' : ''}
                    >
                      NÃO
                      <input
                        type="radio"
                        id="historico2"
                        value="nao"
                        name="historico"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            historicoFamiliar: false,
                          });
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <span className="label">
                    Estilo de vida sedentário
                    <small>({'>'} 8h por dia)</small>
                  </span>
                  <div className="custom-radio">
                    <label
                      className={formInputs.sedentario === 1 ? 'active' : ''}
                    >
                      SIM
                      <input
                        type="radio"
                        id="sedentario1"
                        value="sim"
                        name="sedentario"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sedentario: 1,
                          });
                        }}
                      />
                    </label>
                    <label
                      className={formInputs.sedentario === 0 ? 'active' : ''}
                    >
                      NÃO
                      <input
                        type="radio"
                        id="sedentario2"
                        value="nao"
                        name="sedentario"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sedentario: 0,
                          });
                        }}
                      />
                    </label>
                  </div>
                </div>
                {formInputs.sexo === 'F' && (
                  <div className="form-group">
                    <span className="label">Gravidez</span>
                    <div className="custom-radio">
                      <label
                        className={formInputs.gravidez === 0 ? 'active' : ''}
                      >
                        0 ou 1
                        <input
                          type="radio"
                          id="gravidez1"
                          value="0"
                          name="gravidez"
                          onChange={() => {
                            setFormInputs({
                              ...formInputs,
                              gravidez: 0,
                            });
                          }}
                        />
                      </label>
                      <label
                        className={formInputs.gravidez === 1 ? 'active' : ''}
                      >
                        {'>= 2'}
                        <input
                          type="radio"
                          id="gravidez2"
                          value="1"
                          name="gravidez"
                          onChange={() => {
                            setFormInputs({
                              ...formInputs,
                              gravidez: 1,
                            });
                          }}
                        />
                      </label>
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <span className="label">Idade</span>
                  <div className="custom-range">
                    <InputMask
                      mask="999"
                      maskPlaceholder={null}
                      value={String(formInputs.idade)}
                      onChange={(e) => {
                        setFormInputs({
                          ...formInputs,
                          idade: Number(e.target.value),
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <span className="label">Peso (kg)</span>
                  <div className="custom-range">
                    <InputMask
                      mask="999"
                      maskPlaceholder={null}
                      value={String(formInputs.peso)}
                      onChange={(e) => {
                        setFormInputs({
                          ...formInputs,
                          peso: Number(e.target.value),
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <span className="label">Altura (m)</span>
                  <div className="custom-range">
                    <InputMask
                      type="text"
                      mask={'9.99'}
                      maskPlaceholder={null}
                      value={formatAltura(formInputs.altura)}
                      onChange={(e) => {
                        setFormInputs({
                          ...formInputs,
                          altura: Number(e.target.value),
                        });
                      }}
                    />
                    {/* <input
                      type="number"
                      value={formatAltura(String(formInputs.altura))}
                      onChange={(e) => {
                        setFormInputs({
                          ...formInputs,
                          altura: Number(e.target.value),
                        });
                      }}
                    /> */}
                  </div>
                </div>
                <div className="form-group">
                  <span className="label">Sintomas</span>
                  <div className="custom-radio">
                    <label
                      className={formInputs.sintomas === 1 ? 'active' : ''}
                    >
                      SIM
                      <input
                        type="radio"
                        id="historico1"
                        value="sim"
                        name="historico"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sintomas: 1,
                          });
                        }}
                      />
                    </label>
                    <label
                      className={formInputs.sintomas === 0 ? 'active' : ''}
                    >
                      NÃO
                      <input
                        type="radio"
                        id="historico2"
                        value="nao"
                        name="historico"
                        onChange={() => {
                          setFormInputs({
                            ...formInputs,
                            sintomas: 0,
                          });
                        }}
                      />
                    </label>
                  </div>
                  <div className="info">
                    (Dor, sensação de pernas pesadas, sensação de pernas
                    inchadas, pernas cansadas, cãibras noturnas)
                  </div>
                </div>
                <div className="form-group sintomas">
                  <span className="label">
                    Sintomas clínicos
                    <small>Selecione</small>
                  </span>
                  <div className="grid">
                    {listSintomas.length > 0 &&
                      listSintomas.map((item: Isintomas, key: number) => (
                        <div
                          className={item.selected ? `item active` : `item`}
                          key={key}
                          onClick={() => {
                            const findSolution = listSintomas.findIndex(
                              (index) => index.title === item.title
                            );
                            let newArray = [...listSintomas];
                            newArray[findSolution] = {
                              ...newArray[findSolution],
                              selected: !newArray[findSolution].selected,
                            };
                            setListSintomas(newArray);
                          }}
                        >
                          {item.image}
                          <p>{item.title}</p>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="form-group">
                  <button type="submit">Validar</button>
                </div>
              </form>
            </>
          ) : (
            <>
              <div className="result">
                <div className="reset top">
                  <button onClick={() => goBackQuestion(true)}>
                    Refazer o teste
                  </button>
                </div>
                <div className="info">
                  <div className="vein-age">
                    <p>Idade estimada de suas veias</p>
                    <div className="value">{responseItens.idadeVeia} Anos</div>
                  </div>
                  <div className="imc">
                    <p> Índice de Massa Corporal</p>
                    <div className="value">
                      {responseItens.imc.value.toFixed(1)}
                      {responseItens.imc.obesidade && (
                        <span className="alert">
                          {responseItens.imc.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="resp">
                  <h1>Probabilidade de progressão dos sinais clínicos</h1>
                  <div className="resp-box">
                    <div className="sintomas">
                      <div className="sint blank"></div>
                      {sintomasResp.length > 0 &&
                        sintomasResp.map((sint: Isintomas, key: number) => (
                          <div className="sint" key={key}>
                            <span>{sint.title}</span>
                            {sint.image}
                          </div>
                        ))}
                    </div>
                    <div className="calculate">
                      {responseItens.risks
                        .filter((item) => item.show)
                        .map((resp: IresponseRisks, key: number) => (
                          <div className={`item item${key + 1}`} key={key}>
                            <div className="year">{resp.year}</div>
                            <div className={`resp${key + 1}`}>
                              {resp.typeRisks.c1risk} %
                            </div>
                            <div className={`resp${key + 1}`}>
                              {resp.typeRisks.c2risk} %
                            </div>
                            <div className={`resp${key + 1}`}>
                              {resp.typeRisks.c3risk} %
                            </div>
                            <div className={`resp${key + 1}`}>
                              {resp.typeRisks.c4risk} %
                            </div>
                            <div className={`resp${key + 1}`}>
                              {resp.typeRisks.c5risk} %
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                  {isMobile && (
                    <>
                      {responseItens.risks.filter((item) => item.show).length >
                        1 && (
                        <span className="hint">
                          Deslize para mais informações <AiOutlineRight />
                        </span>
                      )}
                    </>
                  )}
                </div>
                <div className="reset">
                  <button onClick={() => goBackQuestion(false)}>
                    Alterar opções do teste
                  </button>
                  <button onClick={() => goBackQuestion(true)}>
                    Refazer o teste
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Main;
